import React from "react";
import { useForm } from "react-hook-form";

const VAC = (props) => {
	const { next, previous } = props;
	const { handleSubmit, register, errors } = useForm();
	return (
		<div className="container px-5 pt-5 custom-modal">
			<div className="row">
				<h2 className="text-capitalize">
					<h2 className="text-lowercase">eksplode!'s</h2> {" "}
					VAC Program Description
				</h2>
			</div>
			{/* <div className="row">
				<h5 className="my-3 text-justify">
					In addition to eksplode's eac program, we offer Retailers another
					forum for promoting their products/services through our video ad
					contest (vac). Our vac program provides Retailers access to a platform
					designed to allow them to reach a global marketplace through
					eksplode's talent competition.
				</h5>
			</div> */}
			{/* <div className="row">
				<h3 className="mb-3">Here's how it works</h3>
			</div> */}
			<div className="row">
				<ul>
					<li>
						eksplode!'s VAC Program utilizes the Internet and a peer-to-peer
						product placement system to promote products and services listed by
						participating Retailers
					</li>
					<li>
						eksplode!'s VAC program operates as a host for contests in which
						amateur actors and performers, ages 13 years and older, compete for
						cash prizes by creating and recording 15- to 30-second videos
						promoting the product or service listed by the Retailer who posted
						the prize.
					</li>
					<li>
						Each qualifying video is purchased by eksplode! Marketing and shown
						exclusively on its EAC platform for public viewing during each
						30-day Contest Period.
					</li>
					<li>
						During the Contest Period, each VAC viewer (IP Address) may vote for
						their favorite video in every category (i.e., one vote per video
						promoting a product or service), and the video with the most votes
						electronically tabulated wins the cash prize
					</li>
					<li>
						The viewing platform for each video will identify the Retailer whose
						product or service is being featured, a description of the product
						or service, and a hyperlink in which the viewer can be taken
						directly to the Retailer's ! catalog and purchase page
					</li>
					<li>
						If the viewer elects to purchase the product (or service) being
						promoted, or any other product (or service) listed on the Retailer's
						eksplode! catalog, the entire transaction is processed through
						eksplode! Marketing.
					</li>
					<li>
						In processing the transaction, the price of the product (or
						service), all applicable sales tax, eksplode!'s fee of 5%, and any
						other fee (such as shipping & handling) are calculated and billed to
						the customer.
					</li>
					<li>
						Once the transaction is compete, the Retailer will automatically
						receive a Purchase Notice and the remaining balance will be
						simultaneously deposited into the Retailer's PayPal account, or the
						account of its choice.
					</li>
				</ul>
			</div>
			<div className="row mt-3">
				<h3>Instructions for Retailer Participation</h3>
			</div>
			<div className="row mt-3">
				To become an eksplode! Retailer, you must agree to the terms and
				conditions set forth on the Retailer Agreement page, sign up, receive
				your eksplode! Code, then follow these steps:
				<ul>
					<li>
						Select one (or more) products (or services) from your catalog and
						upload each one onto eksplode!'s VAC platform, provide a visual
						depiction and description of the product (or service) you seek to be
						promoted.
					</li>
					<li>
						Choose and then post a cash prize amount (in USD) on your VAC
						Product Page, which you agree to award the winner of the Contest
						Period promoting the corresponding product (or service).
					</li>
					<li>
						Deposit into eksplode!'s (bonded) escrow account the prize amount
						offered for each product (or service) submitted for promotion within
						24 hours of receiving an eksplode! notification, which will be
						promptly issued following the acceptance by eksplode! Marketing of
						the first video submitted for the scheduled Contest Period.
					</li>
				</ul>
				<br />
				Notice: Any failure to comply with Step 3 will result in the suspension
				of the Retailer's account, its catalog taken down, and an immediate
				notification will be issued to all eksplode! Promoters informing them of
				the Retailer's default.
			</div>
			<div className="row d-flex flex-column">
				<div className="d-flex justify-content-start mt-3 align-items-center">
					<input
						type="checkbox"
						className="form-control w-auto mr-3"
						id="read"
						name="read"
						ref={register({
							required: {
								value: true,
								message: "Please read the VAC description",
							},
						})}
					/>
					<p className="mb-0">I have read eksplode!'s VAC program description</p>
				</div>
				<label htmlFor="read" className="error mt-2">
					{errors.read && errors.read.message}
				</label>
			</div>
			<div className="row mt-3 justify-content-center">
				<button
					className="btn btn-solid mx-1"
					style={{ minWidth: "150px" }}
					onClick={previous}
				>
					Previous
				</button>
				<button
					className="btn btn-solid mx-1"
					style={{ minWidth: "150px" }}
					onClick={handleSubmit(next)}
				>
					Next
				</button>
			</div>
		</div>
	);
};

export default VAC;
